﻿import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentPortalProduct`,
  scopes: ExtHubRequest,
});

api.createEntities([
  { name: 'GetProductList' },
  { name: 'GetProductToolkitByCatAndDivList' },
  { name: 'GetProductNames' },
  { name: 'GetProductImage' },
]);

const GetProductNames = () => api.endpoints.GetProductNames.post();
const GetProductList = (body) => api.endpoints.GetProductList.post(body);
const GetProductToolkitByCatAndDivList = (body) =>
  api.endpoints.GetProductToolkitByCatAndDivList.post(body);
const GetProductImage = (body) => api.endpoints.GetProductImage.post(body);

export { GetProductList, GetProductToolkitByCatAndDivList, GetProductNames, GetProductImage };
